const sortKeyEnums = Object.freeze({
  hot: "hot",
  rising: "rising",
  new: "new",
  old: "old",
});

export default sortKeyEnums;
